import React from 'react'
import images from 'Assets/Images'
import { Dropzone } from './../Dropzone'

const DropzoneWithUrlUnstyled = props => {
  var value = (props.input || {}).value || props.value
  return (
    <div>
      {props.label && <label>{props.label}</label>}
      {value ? (
        <a href={value} target="_blank" rel="noreferrer">
          <img className="icon" src={images.openInNewWindowIcon} alt="icon" />
        </a>
      ) : null}
      <Dropzone {...props} accept={'application/pdf'} />
    </div>
  )
}

export { DropzoneWithUrlUnstyled }
